import axios from 'axios'
import { getStoredUrlParams } from 'pp-fe-utils'
import { LOCAL_STORAGE_PARAMS_KEY } from '@/constants'

export default class WebsitesWidgetsServiceClient {
  constructor () {
    this.practiceUuid = getStoredUrlParams(LOCAL_STORAGE_PARAMS_KEY).get('practiceUuid')
    this.client = axios.create({
      baseURL: process.env.VUE_APP_PRACTICE_WIDGETS_SERVICE_DOMAIN,
      headers: {
        'x-api-key': process.env.VUE_APP_PRACTICE_WIDGETS_SERVICE_API_KEY,
        'practice-uuid': this.practiceUuid
      }
    })
  }

  getCustomWidgetSettings () {
    return this.client.get(`/v1/practices/${this.practiceUuid}/custom-widget-settings?slug=multi-channel`)
  }

  getWidgetManagerSettings () {
    return this.client.get(`/v1/practices/${this.practiceUuid}/widget-manager-settings`)
  }
}
